import { ANALYTICS_OPENING_HEADER, staffAnalyticsCustomerPageSchema, staffAnalyticsOpeningSchema, staffAnalyticsOverviewSchema, } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
export function createStaffAnalyticsApi(options) {
    const send = createMemoryTransport(options);
    const base = (customerId) => `/staff/analytics/customers/${encodeURIComponent(customerId)}`;
    return {
        customers: (params, callOptions) => {
            const search = new URLSearchParams();
            if (params?.query !== undefined)
                search.set("query", params.query);
            if (params?.cursor !== undefined)
                search.set("cursor", params.cursor);
            if (params?.limit !== undefined)
                search.set("limit", String(params.limit));
            return send({
                method: "GET",
                path: "/staff/analytics/customers",
                query: search,
                schema: staffAnalyticsCustomerPageSchema,
                signal: callOptions?.signal,
            });
        },
        open: (customerId, tab, commandOptions) => send({
            method: "POST",
            path: `${base(customerId)}/openings`,
            body: { tab },
            schema: staffAnalyticsOpeningSchema,
            idempotencyKey: commandOptions?.idempotencyKey,
            signal: commandOptions?.signal,
        }),
        overview: (customerId, openingId, query, callOptions) => {
            const search = new URLSearchParams();
            if (query?.range !== undefined)
                search.set("range", query.range);
            if (query?.tz !== undefined)
                search.set("tz", query.tz);
            return send({
                method: "GET",
                path: `${base(customerId)}/overview`,
                query: search,
                headers: { [ANALYTICS_OPENING_HEADER]: openingId },
                schema: staffAnalyticsOverviewSchema,
                signal: callOptions?.signal,
            });
        },
    };
}
